// utils.js

import { SERVICE_NAME, DESCRIPTION, PHONE, FAX, EMAIL, OP_HOURS, COVER_AREAS, WEBSITE } from './constants.js';
import { ADDRESS_LINE1, CITY, STATE, POSTAL_CODE, COUNTY, COUNTRY } from './constants.js';
import { NECESSARY_DOCS, NECESSARY_MATS, INSURANCE_ACCEPT, NEXT_STEPS, COST_FREE } from './constants.js';
import { ELIGIBILITY, AVAILABILITY, LANGUAGES, REVIEWED, LAST_VALID } from './constants.js';
import { FACEBOOK, TWITTER, OTHER_SOCIAL, GOOGLE_BUS_LINK, GOOGLE_RATING, GOOGLE_NUM_RATINGS } from './constants.js';

import { TCARE_TAX_1, OPEN_ELIG_2022, DEMOGRAPHICS } from './taxonomy-classes.js';
import {GeocoderAPI} from "../api-v2/geocoder";

// export const getUserFullName = (user) => {
//     if (!user) return '';
//     return user.firstName + ' ' + user.lastName;
// }

// this receives an MSAL .name (first + last)
export const getUserInitials = (fullname) => {
    let inits = '';
    if (!fullname || fullname == '') return '';
    let names = fullname.split(' ');
    if (names[0] && names[0].length > 0) inits += names[0][0];
    if (names[1] && names[1].length > 0) inits += names[1][0];
    return inits;
}

export const intToYesNo = (val) => {
    if (!val) return "no";
    if (val === 0) return "no";
    if (val === "0") return "no";
    return "yes";       // anything else
}

export const boolToYesNo = (bool) => {
    if (!bool) return "no";
    if (bool === 0) return "no";
    if (bool === "0") return "no";
    return "yes";       // anything else
}

export const boolToTrueFalse = (bool) => {
    if (boolToYesNo(bool) === "no") return "false";
    return "true";
}

export const formatPhoneNumber = (phoneNum) => {
    if (!phoneNum) return '';
    let len = phoneNum.length;
    let newNum = '';
    if (phoneNum == '-') return '';
    if (len < 10 || len > 11) return phoneNum;
    // 2129873465 -> 212-987-3465
    if (len == 10) {
        newNum += phoneNum[0];
        newNum += phoneNum[1];
        newNum += phoneNum[2];
        newNum += '-';
        newNum += phoneNum[3];
        newNum += phoneNum[4];
        newNum += phoneNum[5];
        newNum += '-';
        newNum += phoneNum[6];
        newNum += phoneNum[7];
        newNum += phoneNum[8];
        newNum += phoneNum[9];
        return newNum;
    }
    // 12129873465 -> 1-212-987-3465
    if (len == 11) {
        newNum += phoneNum[0];
        newNum += '-';
        newNum += phoneNum[1];
        newNum += phoneNum[2];
        newNum += phoneNum[3];
        newNum += '-';
        newNum += phoneNum[4];
        newNum += phoneNum[5];
        newNum += phoneNum[6];
        newNum += '-';
        newNum += phoneNum[7];
        newNum += phoneNum[8];
        newNum += phoneNum[9];
        newNum += phoneNum[10];
        return newNum;
    }
}

export const formatTimeStr = (timeStr) => {
    if (!timeStr) return '';
    let dt = null;
    try {
        dt = new Date(timeStr);
    } catch(err) {
        return timeStr;
    }
    return dt.toLocaleString();
}

export const formatShortDate = (dateStr) => {
    if (!dateStr) return '';
    let dt = null;
    try {
        dt = new Date(dateStr);
    } catch(err) {
        return dateStr;
    }
    return dt.toLocaleDateString();
}

export const flattenTaxonomy = (taxonomies, taxName) => {
    let keywords = [];
    if (!taxonomies) return keywords;
    if (!taxonomies[taxName]) return keywords;
    keywords = taxonomies[taxName];
    return keywords;
}

// 8/29 - this is incorrect
// needs to take different orders into account
export const shallowArraysEqual = (array1, array2) => {
    return JSON.stringify(array1) === JSON.stringify(array2);
}

// for flat arrays of words - for objects supply propName
export const delimitArray = (arr, delim = ', ', propName = null) => {
    let arrayStr = '';
    let idx = 0;
    if (!arr) return;
    for (const elem of arr) {
        if (idx > 0) arrayStr += delim;
        if (propName) {
            arrayStr += elem[propName];
        } else {
            arrayStr += elem;
        }
        idx++;
    }
    return arrayStr;
}

export const dedupeSimpleArray = (arr) => {
    return [...new Set(arr)];
}

export const getSelectedItems = (arr) => {
    const selectedItems = [];
    if (!arr) return selectedItems;
    for (const elem of arr) {
        if (elem.isSelected) selectedItems.push(elem);
    }
    return selectedItems;
}

export const getSelectedIds = (arr) => {
    return getSelectedItems(arr).map(item => item['service-id']);
}

export const sortArrayItems = (arr, propName, isAscending) => {
    //console.log('utils.js - sortArrayItems: ', propName, isAscending);
    if (isAscending) {
        arr.sort((a, b) => {
            //console.log(a[propName] + ' vs ' + b[propName]);
            if (a[propName] > b[propName]) return 1;
            if (a[propName] < b[propName]) return -1;
            return 0;
        });
    } else {
        arr.sort((a, b) => {
            if (a[propName] > b[propName]) return -1;
            if (a[propName] < b[propName]) return 1;
            return 0;
        });
    }
    arr = arr;          // Svelte refresh
    return arr;
}


export const isReviewEdited = (origService, newService) => {
    // console.log('');
    // console.log('isReviewEdited');
    // console.log('origService:');
    // console.log(origService);
    // console.log('newService:');
    // console.log(newService);

    const origString = JSON.stringify(origService);
    const newString = JSON.stringify(newService);
    
    // might need to use strCompare or similar...
    return origString !== newString;
}

// this is so nulls will not show as diffs for blank values
// Array field types must be set to [] and not '' - formatNullFieldsToEmptyArrays()
export const formatNullFieldsToEmptyStrings = (obj) => {
    if (obj[SERVICE_NAME] === null) obj[SERVICE_NAME] = '';
    if (obj[DESCRIPTION] === null) obj[DESCRIPTION] = '';
    if (obj[PHONE] === null) obj[PHONE] = '';
    if (obj[FAX] === null) obj[FAX] = '';
    if (obj[EMAIL] === null) obj[EMAIL] = '';
    // if (obj[OP_HOURS] === null) obj[OP_HOURS] = '';
    if (obj[COVER_AREAS] === null) obj[COVER_AREAS] = '';
    if (obj[WEBSITE] === null) obj[WEBSITE] = '';

    if (obj[ADDRESS_LINE1] === null) obj[ADDRESS_LINE1] = '';
    if (obj[CITY] === null) obj[CITY] = '';
    if (obj[STATE] === null) obj[STATE] = '';
    if (obj[POSTAL_CODE] === null) obj[POSTAL_CODE] = '';
    if (obj[COUNTY] === null) obj[COUNTY] = '';
    if (obj[COUNTRY] === null) obj[COUNTRY] = '';

    // if (obj[NECESSARY_DOCS] === null) obj[NECESSARY_DOCS] = '';
    // if (obj[NECESSARY_MATS] === null) obj[NECESSARY_MATS] = '';
    // if (obj[INSURANCE_ACCEPT] === null) obj[INSURANCE_ACCEPT] = '';
    if (obj[NEXT_STEPS] === null) obj[NEXT_STEPS] = '';
    if (obj[COST_FREE] === null) obj[COST_FREE] = '';

    if (obj[ELIGIBILITY] === null) obj[ELIGIBILITY] = '';
    if (obj[AVAILABILITY] === null) obj[AVAILABILITY] = '';
    // if (obj[LANGUAGES] === null) obj[LANGUAGES] = '';
    if (obj[REVIEWED] === null) obj[REVIEWED] = '';
    if (obj[LAST_VALID] === null) obj[LAST_VALID] = '';

    if (obj[FACEBOOK] === null) obj[FACEBOOK] = '';
    if (obj[TWITTER] === null) obj[TWITTER] = '';
    if (obj[OTHER_SOCIAL] === null) obj[OTHER_SOCIAL] = '';
    if (obj[GOOGLE_BUS_LINK] === null) obj[GOOGLE_BUS_LINK] = '';
    if (obj[GOOGLE_RATING] === null) obj[GOOGLE_RATING] = '';
    if (obj[GOOGLE_NUM_RATINGS] === null) obj[GOOGLE_NUM_RATINGS] = '';
}

export const formatNullFieldsToEmptyArrays = (obj) => {
    if (obj[OP_HOURS] === null) obj[OP_HOURS] = [];
    if (obj[NECESSARY_DOCS] === null) obj[NECESSARY_DOCS] = [];
    if (obj[NECESSARY_MATS] === null) obj[NECESSARY_MATS] = [];
    if (obj[INSURANCE_ACCEPT] === null) obj[INSURANCE_ACCEPT] = [];
    if (obj[LANGUAGES] === null) obj[LANGUAGES] = [];

}    

export const isFieldDiff = (propName, obj1, obj2) => {
    if (!obj1) return false;
    if (!obj2) return false;
    return obj1[propName] !== obj2[propName];
}

export const isArrayFieldDiff = (propName, obj1, obj2) => {
    if (!obj1) return false;
    if (!obj2) return false;
    return !shallowArraysEqual(obj1[propName], obj2[propName]);
}

export const asyncValidatePostalCode = async (postal) => {
    if (!postal) return false;
    if (postal === '') return false;
    if (postal.length !== 5) return false;
    if (isNaN(postal)) return false;


    const isValidZipCode = await GeocoderAPI.isValidZipCode('us', postal)

    return isValidZipCode
}

export const validatePostalCode = (postal) => {
    if (!postal) return false;
    if (postal === '') return false;
    // if (postal.length !== 5 && postal.length !== 10) return false;
    // if (postal.length === 10 && postal[5] !== '-') return false;
    if (postal.length !== 5) return false;
    if (isNaN(postal)) return false;

    return true
}

// will check for false or 0 (int)
export const getIsPreferredPartner = (svcData) => {
    if (!svcData) return false;
    if (!svcData['preferredPartner'] && !svcData['preferred-partner']) return false;
    if (svcData['preferredPartner']) {
        if (svcData['preferredPartner'] !== 0) return true;
        if (svcData['preferredPartner'] !== false) return true;    
    }
    if (svcData['preferred-partner']) {
        if (svcData['preferred-partner'] !== 0) return true;
        if (svcData['preferred-partner'] !== false) return true;    
    }
    return false;
}
